.root {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: var(--cl-text);
  font-size: var(--cl-fs-base);
  cursor: pointer;
  user-select: none;
}

.disabled {
  cursor: default;
  opacity: 0.6;
}

.input {
  position: absolute;
  opacity: 0;
  width: 1px;
  height: 1px;
  margin: 0;
}

/* Legacy cl-checkbox: 16px square, 1px #C6D2D9 border, blue fill with a white tick when checked. */
.box {
  position: relative;
  flex: none;
  width: 16px;
  height: 16px;
  border: 1px solid var(--cl-border);
  border-radius: var(--cl-radius);
  background: var(--cl-input-bg);
}

.input:checked + .box,
.input:indeterminate + .box {
  border-color: var(--cl-blue);
  background: var(--cl-blue);
}

.input:checked + .box::after {
  content: "";
  position: absolute;
  left: 4.5px;
  top: 1px;
  width: 5px;
  height: 9px;
  border: solid var(--cl-white);
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.input:indeterminate + .box::after {
  content: "";
  position: absolute;
  left: 3px;
  right: 3px;
  top: 6.5px;
  height: 2px;
  background: var(--cl-white);
}

.input:focus-visible + .box {
  box-shadow: var(--cl-blue-focus-ring);
}

.label {
  min-width: 0;
}
